/**
 * Flattens array a single level deep.
 * @param array
 * @returns
 */
function flatten(array) {
    return array?.flat?.() || [];
}
export default flatten;
